import { OfflineNormalTemplate } from './offlineNormal';

export * from './offlineNormal';

export default { OfflineNormalTemplate };
